<template>
  <q-card
    class="card q-mx-auto"
    style="
      min-width: 610px;
      max-width: 610px;
      min-height: 508px;
      max-height: 508px;
    "
    :style="cssVars"
  >
    <div class="row justify-between">
      <div>
        <q-tabs v-model="tab" inline-label>
          <q-tab
            :name="tab.name"
            no-caps
            v-for="(tab, i) in tabs"
            :key="i"
            :disable="tab.disable"
          >
            <div class="row items-center text-accent">
              <q-icon :name="tab.icon" size="xs"> </q-icon>
              <span class="tabTitle q-ml-sm"> {{ tab.label }}</span>
            </div>
          </q-tab>
        </q-tabs>
      </div>
      <q-btn icon="mdi-close" flat round @click="closeDialog" class="q-mr-sm">
      </q-btn>
    </div>
    <div class="row">
      <q-tab-panels v-model="tab" animated class="full-width">
        <q-tab-panel name="suggested">
          <div class="row">
            <span class="text-accent suggestedTitle">
              Upstream's pre-written goal for this Outcome is...
            </span>
          </div>
          <q-scroll-area
            :thumb-style="{
              background: '#162c479c',
              opacity: 1,
              width: '8px',
              height: '8px',
              borderRadius: '20px',
            }"
            style="height: 350px"
          >
            <q-list class="q-mt-lg">
              <q-card
                v-for="(goal, i) in formattedGoalsList"
                :class="`${i % 2 ? '' : 'bg-grey-4'}`"
                :key="i"
                flat
              >
                <q-item v-if="!goal.goals_id" dense>
                  <q-item-section side>
                    <q-checkbox v-model="goal.selected" color="accent">
                    </q-checkbox>
                  </q-item-section>
                  <q-item-section label>
                    <div class="row justify-between">
                      <div>
                        <span class="actionText text-accent">
                          {{ goal.basicGoalAction }}
                        </span>
                        <!-- <span
                          class="q-ml-xs actionText"
                          :style="`color: ${outcomeColor}`"
                        >
                          {{ goal.basicGoal }}
                        </span> -->
                      </div>
                    </div>
                  </q-item-section>
                </q-item>
                <q-item v-else dense>
                  <q-item-section side>
                    <q-icon name="mdi-check-circle" color="primary" size="md">
                    </q-icon>
                  </q-item-section>
                  <q-item-section label>
                    <div class="row">
                      <span class="actionText text-accent">
                        {{ goal.basicGoalAction }}
                      </span>
                      <!-- <span
                        class="q-ml-xs actionText"
                        :style="`color: ${outcomeColor}`"
                      >
                        {{ goal.basicGoal }}
                      </span> -->
                    </div>
                  </q-item-section>
                  <q-item-section side>
                    <q-btn
                      icon="mdi-close"
                      flat
                      round
                      @click="removeSuggestedGoalFromPlan(goal)"
                    >
                    </q-btn>
                  </q-item-section>
                  <q-tooltip> Goal has been added to plan </q-tooltip>
                </q-item>
              </q-card>
            </q-list>
          </q-scroll-area>

          <div class="row q-pt-sm">
            <div class="col">
              Our pre-written goals save you time and allow you to select some
              goals that are common and relevant to this outcome
            </div>
            <div class="col-auto">
              <q-btn
                :style="`background-color: ${outcomeColor}`"
                class="button q-ml-sm"
                :disable="selectedGoals.length <= 0"
                no-caps
                @click="addSuggestedGoals"
              >
                <span class="buttonText text-white">Add to my plan</span>
              </q-btn>
            </div>
          </div>
        </q-tab-panel>
        <q-tab-panel name="goalBuilder" class="q-pa-none">
          <!--GOAL BUILDER-->
          <div v-if="$route.params.goalID">
            <goal-builder-form
              :selectedData="selectedData"
              :outcomeColor="outcomeColor"
              @closeForm="closeForm"
            ></goal-builder-form>
          </div>
          <div v-else>
            <div v-if="!isBuildGoal" class="q-pa-md">
              <div class="row">
                <sustainability-data-table
                  style="height: 420px !important"
                  ref="datatable"
                  :data="filteredData"
                  :columns="columns"
                  updateBody
                  bodyHoverColor="#4ac7e933"
                  bodyAltColor="#F6F6F6"
                  flat
                  :hideBottom="true"
                  rowKey="sources_id"
                  :square="true"
                  separator="none"
                  headerBgColor="white"
                  :headerDark="true"
                  id="solutionsTable"
                  @onSelected="selectSource"
                >
                  <!--LIST TILE LAYOUT-->
                  <template slot="body" slot-scope="data">
                    <q-tr
                      v-ripple
                      class="bg-white text-black"
                      @click="$refs.datatable.handleClick(null, data.props.row)"
                      @dblclick="
                        $refs.datatable.handleDoubleClick(null, data.props.row)
                      "
                      :props="data.props"
                    >
                      <template
                        v-for="column in data.props.cols"
                        :name="`body-cell-${column.name}`"
                        v-bind:props="data.props"
                      >
                        <q-td
                          v-if="column.name == 'sourceName'"
                          :key="column.name"
                          :props="data.props"
                        >
                          <div class="sourceColumn-div">
                            <span class="sourceColumn">
                              {{ data.props.row.name }}
                              <q-tooltip>
                                {{ data.props.row.name }}
                              </q-tooltip>
                            </span>
                          </div>
                        </q-td>

                        <q-td
                          v-else-if="column.name == 'total'"
                          :key="column.name"
                          :props="data.props"
                        >
                          <div class="totalColumn-div">
                            <span class="sourceColumn" style="display: inline">
                              {{ data.props.row.total }}
                            </span>
                            <span
                              class="totalColumn-unit text-accent"
                              style="display: inline"
                            >
                              {{ data.props.row.unit }}
                            </span>
                          </div>
                        </q-td>

                        <q-td
                          v-else-if="column.name == 'emissionsFactor'"
                          :key="column.name"
                          :props="data.props"
                        >
                          <div class="row items-center">
                            <span class="emission">
                              {{
                                !data.props.row.customEmissionsFactor
                                  ? getTotalDefaultEmission(data.props.row)
                                    ? getTotalDefaultEmission(
                                        data.props.row
                                      ).toFixed(2)
                                    : getTotalDefaultEmission(data.props.row)
                                  : data.props.row.customEmissionsFactor
                                  ? isNaN(
                                      parseFloat(
                                        data.props.row.customEmissionsFactor
                                          .totalValue
                                      )
                                    )
                                    ? ""
                                    : parseFloat(
                                        data.props.row.customEmissionsFactor
                                          .totalValue
                                      )
                                  : ""
                              }}
                            </span>
                            <span class="unit"> tCO2-e</span>
                          </div>
                        </q-td>

                        <q-td v-else :key="column.name" :props="data.props">
                          {{ column.value }}
                        </q-td>
                      </template>
                    </q-tr>
                  </template>
                </sustainability-data-table>
              </div>
            </div>
            <div v-else>
              <!--ADDING goal builder form-->
              <div class="row items-center">
                <q-btn
                  v-if="!isUpdating"
                  icon="mdi-arrow-left"
                  flat
                  @click="isBuildGoal = false"
                ></q-btn>
                <span class="text-accent suggestedTitle">
                  Please build a data goal by choosing the below options
                </span>
              </div>

              <goal-builder-form
                :selectedData="selectedData"
                :outcomeColor="outcomeColor"
                @closeForm="closeForm"
              ></goal-builder-form>
            </div>
          </div>
        </q-tab-panel>
        <q-tab-panel name="writeYourOwn">
          <div style="height: 390px">
            <span class="text-accent suggestedTitle">
              Please write a goal for this outcome
            </span>
            <div class="row items-center" style="margin-top: 10px">
              <q-input
                filled
                style="width: 90%"
                v-model="writeYourOwnGoal"
              ></q-input>
              <span
                class="q-mt-sm"
                :style="`
                  color: ${outcomeColor};
                    font-family: 'Montserrat';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 13px;
                  `"
              >
                *Self written goals will have no suggested solutions
              </span>
            </div>
            <div class="row q-col-gutter-sm">
              <div class="col-12">
                <span class="text-accent suggestedTitle">
                  Add an Image (Will be used in the display of goals, your full
                  plan & reporting)
                </span>
              </div>
              <div class="col-12">
                <!-- <div
                  style="
                    width: 300px;
                    height: 165px;
                    background: #f6f6f6;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <span
                    style="font-size: 4rem; font-weight: 900"
                    class="text-accent2"
                    >+</span
                  >
                </div> -->
                <croppa
                  ref="imgCroppa"
                  :height="145"
                  :width="218"
                  v-model="myCroppa"
                  remove-button-color="#68c6d2"
                  :show-loading="true"
                  :loading-size="50"
                  crossOrigin="anonymous"
                  :quality="2"
                  :prevent-white-space="false"
                ></croppa>
              </div>
              <div class="col-12">
                <span
                  class="q-mt-sm"
                  :style="`
                  color: ${outcomeColor};
                    font-weight: 400;
                    font-size: 0.8rem;
                  `"
                >
                  The default image we use for “write my own” goal is the
                  outcome default image. We suggest you change it to pesonalise
                  your report.
                </span>
              </div>
              <div class="col-12">
                <span
                  class="q-mt-sm"
                  :style="`
                  color: black;
                    font-weight: 400;
                    font-size: 0.8rem;
                  `"
                >
                  Need a stock image? try these
                  <a
                    href="https://pexels.com"
                    target="_blank"
                    class="text-primary"
                    style="text-decoration: none"
                  >
                    pexels.com
                  </a>
                  ||
                  <a
                    href="https://unsplash.com"
                    target="_blank"
                    class="text-primary"
                    style="text-decoration: none"
                  >
                    unsplash.com
                  </a>
                </span>
              </div>
            </div>
          </div>
          <div class="row justify-end">
            <q-btn
              :style="`background-color: ${outcomeColor}`"
              class="button q-ml-sm"
              no-caps
              @click="addCustomGoal(true)"
              v-if="!isUpdating"
            >
              <span class="buttonText text-white">Add to my plan</span>
            </q-btn>
            <div v-else class="row">
              <q-btn
                :style="`background-color: ${outcomeColor}`"
                class="button q-ml-sm"
                no-caps
                @click="saveCustomGoal(true, true)"
              >
                <span class="buttonText text-white">Remove from plan</span>
              </q-btn>
              <q-btn
                :style="`background-color: ${outcomeColor}`"
                class="button q-ml-sm"
                no-caps
                @click="saveCustomGoal(false, true)"
              >
                <span class="buttonText text-white">Update Goal</span>
              </q-btn>
            </div>
          </div>
        </q-tab-panel>
      </q-tab-panels>
    </div>
  </q-card>
</template>

<script>
import { mapGetters } from "vuex";
import YearPicker from "@/components/generalComponents/yearPicker.vue";
import Topbar from "@/components/topbar/topbar.vue";
import SustainabilityDropdown from "@/components/sustainabilityDropdown/sustainabilityDropdown.vue";
import SustainabilityDataTable from "@/components/datatable/sustainabilityDatatable.vue";
import GoalBuilderForm from "@/components/goalBuilder/workspaceGoalBuilder/goalBuilderForm/goalBuilderForm.vue";
export default {
  components: {
    YearPicker,
    Topbar,
    SustainabilityDropdown,
    SustainabilityDataTable,
    GoalBuilderForm,
  },
  computed: {
    ...mapGetters({
      basicGoalsList: "basicGoals/list",
      selectedBasicGoal: "basicGoals/current",
      currentUserData: "auth/currentUserData",
      selectedData: "sources/data/selectedData",
      sourcesList: "sources/sourcesOutcomesList",
      sourcesWithNoGoals: "sources/data/list",
      selectedGoal: "goals/selectedGoal",
    }),
    selectedGoals() {
      return this.formattedGoalsList.filter((e) => e.selected);
    },
    cssVars() {
      return {
        "--outcome-color": this.outcomeColor,
      };
    },
    columns() {
      let currentColumns = [
        {
          name: "sourceName",
          label: "Source",
          align: "left",
          field: "name",
          boldItems: true,
          capsHeader: true,
          boldHeader: true,
          headerTextStyle: `color:${this.cssVars["--outcome-secondary"]}!important;`,
          style:
            "min-width: 200px;max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        },

        {
          name: "total",
          label: "Total",
          align: "left",
          field: "total",
          boldHeader: true,
          headerTextStyle: `font-family: 'Montserrat';font-style: normal;font-weight: 700;font-size: 14px;color:${this.cssVars["--outcome-secondary"]}!important;`,
          extendedCSS:
            "font-family: 'Montserrat';font-style: normal;font-weight: 400;font-size: 10px;margin-left: 2px;",
          style:
            "min-width: 100px;max-width: 100px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        },
        {
          name: "emissionsFactor",
          label: "tCO2-e",
          align: "left",
          field: "emissionsFactor",
          boldHeader: true,
          headerTextStyle: `font-family: 'Montserrat';font-style: normal;font-weight: 700;font-size: 14px;color:${this.cssVars["--outcome-secondary"]}!important;`,
          extendedCSS:
            "font-family: 'Montserrat';font-style: normal;font-weight: 400;font-size: 10px;margin-left: 2px;",
          style:
            "min-width: 110px;max-width: 110px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          format: (val, row) => {},
        },
      ];
      if (this.selectedOutcome.id) {
        currentColumns.slice(2);
      }
      return currentColumns;
    },
    filteredData() {
      let currentData = this.sourcesWithNoGoals;

      currentData = currentData.slice();
      currentData = currentData.filter((e) => e.total);
      currentData = currentData.filter((e) => !this.isGoalSet(e));
      let unknownSourceIndex = currentData.findIndex(
        (e) => e.name == "Unknown Source"
      );

      if (unknownSourceIndex > -1) {
        currentData.splice(unknownSourceIndex, 1);
      }
      return currentData;
    },
  },
  props: {
    outcomeColor: {
      type: String,
      default: "#162C47",
    },
    defaultTab: {
      type: String,
      default: "suggested",
    },
    workspaceMode: {
      type: Boolean,
      default: false,
    },
    selectedOutcome: {
      default: null,
    },
  },
  mounted() {
    this.initBasicGoalsList();
    this.initTabs();
    this.init();
    this.handleRoute();
  },
  data: () => ({
    tab: "suggested",
    formattedGoalsList: [],
    tabs: [
      {
        sort: 1,
        name: "suggested",
        label: "Suggested",
        icon: "fas fa-lightbulb",
        disable: false,
      },
      {
        sort: 2,
        name: "goalBuilder",
        label: "Goal Builder",
        icon: "mdi-wrench",
        disable: false,
      },
      {
        sort: 3,
        name: "writeYourOwn",
        label: "Write Your Own",
        icon: "mdi-file-document-box",
        disable: false,
      },
    ],

    //goalBuilder
    actionSelect: "Reduce",
    actionOptions: ["Reduce", "Increase"],
    sourceSelect: null,
    reductionPercentage: 5,
    yearDialog: false,
    target: "",
    reduction: "",
    firstModel: 1,
    arrayMarkerLabel: [
      { value: 5, label: "5%" },
      { value: 10, label: "10%" },
    ],

    //write your own
    writeYourOwnGoal: "",

    isBuildGoal: false,
    selectedYear: new Date().getFullYear(),

    isUpdating: false,

    //croppa
    myCroppa: {},
    changeImage: false,
  }),
  watch: {
    $route: {
      handler() {
        this.handleRoute();
      },
      deep: true,
    },
  },
  methods: {
    handleRoute() {
      if (this.$route.params.hasOwnProperty("goalID")) {
        this.$store
          .dispatch("goals/loadByID", this.$route.params.goalID)
          .then(() => {
            this.filterTabsBasedOnGoal(this.selectedGoal);
          });
      }
    },
    closeForm() {
      this.isBuildGoal = false;
      this.$emit("callGoalSummaryInit");
      this.closeDialog();
    },
    isGoalSet(data) {
      if (data.goalBuilderGoal) {
        return true;
      } else {
        return false;
      }
    },
    selectSource(data) {
      this.isBuildGoal = true;
      this.$store.dispatch("sources/data/loadBySourceID", {
        id: data[0].sources_id,
        year: this.$moment().format("YYYY"),
      });
    },
    getTotalDefaultEmission(data) {
      //get the chosen year
      let selectedYear = this.selectedYear;

      if (data.emissionsFactor.length > 0) {
        //get the latest emissions factor of the selected year
        let latestEmissionFactor = data.emissionsFactor[0];
        data.emissionsFactor.forEach((e) => {
          if (parseFloat(e.created_at.split("-")[0]) <= selectedYear) {
            latestEmissionFactor = { ...e };
          }
        });

        if (latestEmissionFactor.unit.toLowerCase() == "kgco2-e") {
          return (
            (parseFloat(data.total) *
              parseFloat(latestEmissionFactor.emissionsFactor)) /
            1000
          );
        } else {
          return (
            parseFloat(data.total) *
            parseFloat(latestEmissionFactor.emissionsFactor)
          );
        }
      }
    },
    selectYear(val) {
      this.selectedYear = val.split("/")[0];
      this.$store.dispatch("sources/data/loadAllByOutcomesIDAndYearWithGoals", {
        id: this.selectedOutcome.id,
        year: this.$refs.yearPicker.selectedYear,
      });
    },
    initBasicGoalsList() {
      if (this.$route.params.hasOwnProperty("outcomesID")) {
        this.formattedGoalsList = [];
        this.$store
          .dispatch(
            "basicGoals/loadAllByOutcomeID",
            this.$route.params.outcomesID
          )
          .then(() => {
            this.basicGoalsList.forEach((e) => {
              this.formattedGoalsList.push({ ...e, selected: false });
            });
          });
      }
    },
    async init() {
      this.$store.dispatch("sources/data/loadAllByOutcomesIDAndYearWithGoals", {
        id: this.selectedOutcome.id,
        year: this.selectedYear,
      });
    },
    initTabs() {
      this.tabs.sort((a, b) => (a.sort > b.sort ? 1 : -1));
    },
    filterTabsBasedOnGoal(goal) {
      if (goal.basicGoals_id) {
        this.tabs[0].disable = false;
        this.tabs[1].disable = true;
        this.tabs[2].disable = true;
        this.tab = "suggested";
        this.formattedGoalsList = this.formattedGoalsList.filter(
          (e) => e.id == goal.basicGoals_id
        );
        this.isUpdating = true;
      } else if (goal.writeYourOwnGoal) {
        this.tabs[0].disable = true;
        this.tabs[1].disable = true;
        this.tabs[2].disable = false;
        this.tab = "writeYourOwn";
        this.writeYourOwnGoal = this.selectedGoal.writeYourOwnGoal;
        this.isUpdating = true;
      } else {
        this.tabs[0].disable = true;
        this.tabs[1].disable = false;
        this.tabs[2].disable = true;
        this.tab = "goalBuilder";
        this.$store
          .dispatch("sources/data/loadBySourceID", {
            id: goal.sources_id,
            currentGoal: true,
          })
          .then(() => {
            this.$store.dispatch("goals/loadByIDWithEmissionsFactor", {
              id: this.selectedData.goalBuilderGoal.id,
              year: this.selectedData.date.split("-")[0],
            });
          });
      }
    },
    initStats() {
      if (this.reductionPercentage || this.reductionPercentage == 0) {
        this.target =
          this.selectedData.total -
          this.selectedData.total * (this.reductionPercentage / 100);
        this.reduction =
          this.selectedData.total * (this.reductionPercentage / 100);
      }
    },
    onReductionChange() {
      if (this.reduction) {
        this.reductionPercentage =
          (this.reduction / this.selectedData.total) * 100;
      }
    },
    onTargetChange() {
      if (this.target) {
        this.reduction = this.selectedData.total - this.target;
        this.reductionPercentage =
          (this.reduction / this.selectedData.total) * 100;
      }
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    async addSuggestedGoals() {
      let selectedGoals = this.formattedGoalsList.filter((e) => e.selected);
      let formattedBusinessGoals = [];
      selectedGoals.forEach((e) => {
        formattedBusinessGoals.push({
          sources_id: e.sources_id,
          business_id: this.currentUserData.sustainabilityBusiness_id,
          basicGoals_id: e.id,
        });
      });
      let result = await this.$store.dispatch(
        "goals/business/newGoals",
        formattedBusinessGoals
      );
      this.$emit("callGoalSummaryInit");
      this.initBasicGoalsList();
      if (result.Result == "Success") {
        this.$q.notify({
          position: "top-right",
          type: "positive",
          message: result.Response.Message,
        });
      } else {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an Error, Please try again later",
        });
      }
    },
    async removeSuggestedGoalFromPlan(goal) {
      this.$swal({
        title: "Warning",
        text: "You are about to delete this Item. This is irreversible",
        type: "warning",
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        showCancelButton: true,
        confirmButtonColor: "#f58122",
      }).then(async (res) => {
        if (res.value) {
          let payload = {
            id: goal.goals_id,
            basicGoals_id: null,
            deleted_at: true,
          };
          let result = await this.$store.dispatch("goals/save", payload);
          this.$emit("callGoalSummaryInit");
          this.initBasicGoalsList();
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
            if (this.$route.params.hasOwnProperty("goalID")) {
              this.closeDialog();
            }
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        }
      });
    },
    async addCustomGoal(writeYourOwn = false) {
      let payload = null;
      if (!writeYourOwn) {
        payload = {
          sources_id: this.selectedData.sources_id,
          action: this.actionSelect,
          due_at: this.selectedYear,
          reductionPercentage: this.reductionPercentage,
        };
      } else if (writeYourOwn) {
        payload = {
          writeYourOwnGoal: this.writeYourOwnGoal,
          outcomes_id: this.selectedOutcome.id,
        };

        if (this.myCroppa && this.myCroppa.imageSet) {
          payload.image = {
            dataUrl: this.myCroppa.generateDataUrl(),
          };
        } else {
          delete payload.imageUrl;
        }
      }

      let result = await this.$store.dispatch("goals/new", payload);
      this.$emit("callGoalSummaryInit");
      this.closeDialog();
      if (result.Result == "Success") {
        this.$q.notify({
          position: "top-right",
          type: "positive",
          message: "Goal has been added to plan",
        });
      } else {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an Error, Please try again later",
        });
      }
    },
    async saveCustomGoal(isDelete = false, writeYourOwn = false) {
      let payload = {
        ...this.selectedGoal,
        action: this.actionSelect,
        due_at:
          typeof this.selectedYear === "number"
            ? this.selectedYear + "/01/01"
            : this.selectedYear,
        reductionPercentage: this.reductionPercentage,
      };
      if (writeYourOwn) {
        payload = {
          ...this.selectedGoal,
          writeYourOwnGoal: this.writeYourOwnGoal,
        };
        if (this.myCroppa && this.myCroppa.imageSet) {
          payload.image = {
            dataUrl: this.myCroppa.generateDataUrl(),
          };
        } else {
          delete payload.imageUrl;
        }
      }
      if (isDelete) {
        payload = {
          ...payload,
          deleted_at: true,
        };
        if (writeYourOwn) {
          this.writeYourOwnGoal = null;
        }
      }

      let result = await this.$store.dispatch("goals/save", payload);
      this.$emit("callGoalSummaryInit");
      if (result.Result == "Success") {
        this.$q.notify({
          position: "top-right",
          type: "positive",
          message: result.Response.Message,
        });
        this.closeDialog();
      } else {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an Error, Please try again later",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tabTitle {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
}

.suggestedTitle {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
}

.actionText {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
}

.buttonText {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 9px;
}

.goalBuilder__sentence {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
}

.goalBuilder__stats__title {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
}

.goalBuilder__stats__font {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 900;
  font-size: 18.9913px;
}

.goalBuilder__stats__unit {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 900;
  font-size: 11px;
}
.button {
  width: 133px;
}

.dropdownTitle {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
}

.q-slider__selection {
  color: var(--outcome-color);
}

.emission {
  width: 40px;
  font-family: "Montserrat";
  font-style: normal;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-weight: 400;
  font-size: 14px;
  color: var(--outcome-secondary);
}

.unit {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
}

.totalColumn-unit {
  margin-left: 20px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
}
.totalColumn-div {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: none;
  display: inline;
}

.sourceColumn {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  overflow: hidden;
  color: var(--outcome-secondary);
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
